import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateFilesAndHistoryQueries } from "@/queries/refetch-files-and-history";
import { ProjectContext } from "@/stores/project-provider";

export const useAddFolder = (basePath: string) => {
  const { id: projectId } = useContext(ProjectContext);
  const invalidateFilesAndHistoryQueries = useInvalidateFilesAndHistoryQueries();
  return useMutationWithErrorHandler(async (folderName: string) => {
    const path = basePath ? `${basePath}${folderName}` : folderName;
    await getRanaApiV1().FilesApi.projectDirectoryCreate({
      projectId,
      path,
    });
    invalidateFilesAndHistoryQueries(projectId, path);
  });
};
